import { render, staticRenderFns } from "./GraficoPie.vue?vue&type=template&id=6a63f9d4&"
import script from "./GraficoPie.vue?vue&type=script&lang=ts&"
export * from "./GraficoPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports